import type { ServerEventPayload } from "./types";

/**
 * Frontend'den backend'e event gönderir.
 * Consent durumuna bakılmaksızın TÜM istekleri sunucuya iletir.
 */
export const sendServerEvent = async (
  payload: ServerEventPayload,
): Promise<void> => {
  try {
    await fetch("/api/tracking/server-event", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
      keepalive: true,
    });
  } catch {
    // tracking hatası akışı bozmasın
  }
};

export const generateEventId = (): string => {
  if (typeof crypto !== "undefined" && "randomUUID" in crypto) {
    return crypto.randomUUID();
  }
  return `evt_${Date.now()}_${Math.random().toString(36).slice(2)}`;
};